import React, { useState } from "react";
import { toast } from "react-toastify";
import Checkbox from "../components/common/checkbox";
import Input from "../components/common/input";
import Select from "../components/common/select";
import http from "../services/http";
import logo from "../assets/flaskLogo.png";

const sites = [
  { id: "BA", name: "Bardney" },
  { id: "BU", name: "Bury" },
  { id: "CA", name: "Cantley" },
  { id: "NE", name: "Newark" },
  { id: "WI", name: "Wissington" },
  { id: "CO", name: "Central Office" },
];

const Register = ({ history }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [site, setSite] = useState("");
  const [liveData, setLiveData] = useState(false);
  const [viewGrabbers, setViewGrabbers] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      firstName,
      lastName,
      email,
      site,
      permissions: {
        liveData,
        viewGrabbers,
      },
    };
    try {
      setLoading(true);
      await http.post("/auth/register", payload);
      setLoading(false);
      toast.success("Please check your inbox");
      history.push("/login");
    } catch (ex) {
      setLoading(false);
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  };
  return (
    <form
      className="mt-5"
      style={{ width: "100%", maxWidth: "400px", margin: "auto" }}
    >
      <div className="mx-auto" style={{ width: 275 }}>
        <img className="img-fluid" src={logo} alt="British Sugar Logo" />
      </div>
      <h3>Register</h3>
      <p className="text-muted">
        Only valid British Sugar email accounts may be used
      </p>
      <Input
        name="firstName"
        label="First Name"
        placeholder="First Name"
        error=""
        value={firstName}
        onChange={(e) => setFirstName(e.currentTarget.value)}
      />
      <Input
        name="lastName"
        label="Last Name"
        placeholder="Last Name"
        error=""
        value={lastName}
        onChange={(e) => setLastName(e.currentTarget.value)}
      />
      <Input
        name="email"
        label="Email"
        placeholder="example@britishsugar.com"
        error=""
        value={email}
        onChange={(e) => setEmail(e.currentTarget.value)}
      />
      <Select
        name="site"
        label="Site"
        placeholder="Site"
        value={site}
        options={sites}
        error=""
        onChange={(e) => setSite(e.currentTarget.value)}
      />
      <div className="row my-4">
        <div className="col d-flex justify-content-center">
          <Checkbox
            name="liveData"
            label="Live Data"
            checked={liveData}
            onClick={(e) => setLiveData(e.currentTarget.checked)}
          />
        </div>
        <div className="col d-flex justify-content-center">
          <Checkbox
            name="viewGrabbers"
            label="Data Grabber"
            checked={viewGrabbers}
            onClick={(e) => setViewGrabbers(e.currentTarget.checked)}
          />
        </div>
      </div>
      <button
        className="btn btn-success"
        onClick={handleSubmit}
        disabled={loading}
      >
        Register
      </button>
    </form>
  );
};

export default Register;
